import React, { Component } from "react";

import RouteManager, { PAGE_ROUTES } from "../../managers/RouteManager";
import PageDesigner from "../page_designer/PageDesigner";
import { PAGE_TYPE } from "../page_designer/ComponentList";
import Stepper from "../common/Stepper";
import FunnelManager from "./FunnelManager";
import NewPagePopup from "./NewPagePopup";
import { DKLabel, DKButton, DKIcons, showAlert } from "deskera-ui-library";
import { swapArrayElement } from "../../utility/Utility";
import SavePopup from "../common/SavePopup";
import FunnelService from "../../services/funnel";
import SharePopup from "../common/SharePopup";

class FunnelBuilder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      steps: FunnelManager.getAllFunnelSteps(),
      pageData: FunnelManager.getCurrentStepData()
        ? FunnelManager.getCurrentStepData().templateData
        : null,
      needNewPagePopup: false,
      isEditTapped: false,
      needSavePopup: false,
      needSharePopup: false,
    };

    this.pageDataToSave = null;
    this.pageType = PAGE_TYPE.FUNNEL;
  }
  componentDidMount() {
    RouteManager.setPresenter(this);
    if (!FunnelManager.isFunnelDataAvailable() && this.props.match.params.id) {
      FunnelManager.fetchFunnelDataById(this.props.match.params.id, () => {
        this.refreshPage();
      });
    }
  }

  refreshPage = () => {
    this.setState({
      steps: FunnelManager.getAllFunnelSteps(),
      pageData: FunnelManager.getCurrentStepData()
        ? FunnelManager.getCurrentStepData().templateData
        : null,
    });
  };

  render() {
    return (
      <div
        className="parent-width align-items-start parent-height "
        style={{ marginTop: -7 }}
      >
        {this.getHeader()}
        <div className="row justify-content-center mt-l">
          <Stepper
            data={this.state.steps}
            currentIndex={FunnelManager.getCurrentStepIndex()}
            onClick={(index) => {
              FunnelManager.setCurrentStepIndex(index);
              this.refreshPage();
            }}
            draggable={true}
            onStepDrop={(source, target, step) =>
              this.onStepDrop(source, target, step)
            }
          />
        </div>

        {this.state.pageData && (
          <PageDesigner
            type={this.pageType}
            components={this.state.pageData.designElements}
            scripts={this.state.pageData.scripts}
            metaData={this.state.pageData.metaData}
            hash={this.state.pageData.hash}
            onDataChange={(data) => {
              this.pageDataToSave = data;
              FunnelManager.updateCurrentStepTemplateData(
                this.pageDataToSave.json
              );
            }}
            onSave={() => {
              this.saveTapped();
            }}
          />
        )}
        {this.state.needNewPagePopup && this.getNewPagePopup()}
        {this.state.needSavePopup && this.getSavePopup()}
        {this.state.needSharePopup && this.getSharePopup()}
      </div>
    );
  }
  onStepDrop = (source, target, step) => {
    const hash = FunnelManager.getCurrentFunnelData()[0].templateData.hash;
    let steps = [...this.state.steps];
    swapArrayElement(FunnelManager.getCurrentFunnelData(), source, target);
    swapArrayElement(steps, source, target);
    FunnelManager.getCurrentFunnelData()[0].templateData.hash = hash;
    this.setState({ steps }, this.refreshPage);
  };
  getHeader() {
    return (
      <div className="row justify-content-between">
        <DKLabel text="Funnel Setup" className="fw-m fs-l" />
        <div className="row" style={{ width: "auto" }}>
          <DKButton
            icon={DKIcons.ic_edit}
            className="bg-white border-m"
            onClick={() => {
              this.setState({ isEditTapped: true }, () => {
                this.showNewPagePopup();
              });
            }}
          />
          <DKButton
            icon={DKIcons.ic_add}
            title="Page"
            className="bg-white border-m ml-r"
            onClick={this.showNewPagePopup}
          />
          <DKButton
            title="Page"
            icon={DKIcons.white.ic_delete}
            className="bg-red border-m ml-r text-white"
            onClick={this.showDeletePageAlert}
          />
          {FunnelManager.isFunnelDataAvailable() && (
            <DKButton
              icon={DKIcons.ic_share}
              className="bg-white border-m ml-r"
              onClick={this.showSharePopup}
            />
          )}
          <DKButton
            title="Save"
            className="bg-app text-white ml-r"
            onClick={this.saveTapped}
          />
        </div>
      </div>
    );
  }

  gotoDomainPage = () => {
    RouteManager.navigateToPage(PAGE_ROUTES.FUNNEL_DOMAIN);
  };

  saveTapped = () => {
    if (FunnelManager.isFunnelDataAvailable()) {
      this.updateFunnel();
    } else {
      this.showSavePopup();
    }
  };

  ///////////////////////////////////////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////////////////////////////////////

  getNewPagePopup = () => {
    return (
      <NewPagePopup
        data={
          this.state.isEditTapped === true
            ? FunnelManager.getCurrentStepData()
            : null
        }
        onCancel={this.hidePagePopup}
        onSave={this.saveNewPage}
      />
    );
  };

  showNewPagePopup = () => {
    this.setState({ needNewPagePopup: true });
  };
  hidePagePopup = () => {
    this.setState({ isEditTapped: false, needNewPagePopup: false });
  };

  saveNewPage = (data) => {
    if (this.state.isEditTapped) {
      FunnelManager.updateCurrentStepData(data);
    } else {
      FunnelManager.addNewStep(data);
    }
    this.refreshPage();
    this.hidePagePopup();
  };

  ///////////////////////////////////////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////////////////////////////////////

  showDeletePageAlert = () => {
    if (FunnelManager.getCurrentFunnelData().length === 1) {
      showAlert(
        "Can't delete page!",
        "Your funnel should have at-least one page."
      );
      return;
    }

    const buttons = [
      {
        title: "Cancel",
        className: "bg-gray1 border-m",
      },
      {
        title: "Delete",
        className: "bg-red text-white ml-r",
        onClick: () => {
          FunnelManager.deleteCurrentStep();
          this.refreshPage();
        },
      },
    ];
    showAlert(
      "Delete Page?",
      "Deleting this page will delete it permanently, you will not be able to restore it.",
      buttons
    );
  };

  ///////////////////////////////////////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////////////////////////////////////

  getSavePopup() {
    return (
      <SavePopup
        title="New Funnel"
        header="Funnel Name"
        headerIcon="📝 "
        subHeader="Enter a name to help you remember what this funnel is all about. Only you will see this."
        onCancel={this.onPopupCancel}
        onSave={this.onPopupSave}
        allowDomainSelection={true}
      />
    );
  }

  //////////////////////////////////////////////////////

  showSavePopup = () => {
    this.setState({
      needSavePopup: true,
    });
  };
  hideSavePopup = () => {
    this.setState({
      needSavePopup: false,
    });
  };

  //////////////////////////////////////////////////////

  onPopupSave = (title, domain) => {
    this.saveFunnel(title, domain);
  };
  onPopupCancel = () => {
    this.hideSavePopup();
  };

  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////

  saveFunnel(title, domain) {
    let data = {
      funnelName: title,
      domain: domain,
    };
    const request = FunnelManager.getRequestToSaveFunnel(data);
    FunnelService.save(
      request,
      (data) => {
        this.funnelSaved(data);
      },
      (error) => {}
    );
  }

  updateFunnel() {
    const request = FunnelManager.getRequestToUpdateFunnel();
    FunnelService.update(
      request,
      FunnelManager.getFunnelRecordId(),
      (data) => {
        this.funnelSaved(data);
      },
      (error) => {}
    );
  }

  funnelSaved(data) {
    FunnelManager.setFunnelDataFromAPI(data);
    RouteManager.navigateToPage(PAGE_ROUTES.FUNNEL_DOMAIN);
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////

  getSharePopup() {
    return (
      <SharePopup
        style={{ top: 110, right: 85, zIndex: 100 }}
        directLink={FunnelManager.getDirectLink()}
        onClose={this.hideSharePopup}
      />
    );
  }

  showSharePopup = () => {
    this.setState({ needSharePopup: true });
  };

  hideSharePopup = () => {
    this.setState({ needSharePopup: false });
  };

  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////
}

export default FunnelBuilder;
